      {/* Marketing site for Zoco Fruits */}

export const BUSINESS = {
  name: "Zoco Fruits",
  tagline: "Fruits & Vegetables Delivery",
  whatsappRaw: "34685659886",
  whatsappDisplay: "+34 685 659 886",
  phone: "685 659 886",
  email: "zocofruits@gmail.com",
  address: "Avda. Málaga 107",
  city: "La Cala del Moral",
  region: "Málaga, España",
  hours: [
    { days: "Lunes – Viernes", time: "09:00 – 14:30 · 17:15 – 20:30" },
    { days: "Sábado", time: "09:00 – 14:30" },
    { days: "Domingo", time: "09:00 – 14:30" },
  ],
  mapsQuery: "Avda+Málaga+107,+La+Cala+del+Moral,+Málaga",
};

export const waLink = (message) => {
  const text = encodeURIComponent(message || "Hola Zoco Fruits, me gustaría hacer una consulta.");
  return `https://wa.me/${BUSINESS.whatsappRaw}?text=${text}`;
};

// Showcase categories — sin detalle de proveedores ni precios
export const SHOWCASE = [
  {
    id: "especias",
    label: "Especias",
    title: "Especias",
    subtitle: "Aromas que despiertan la cocina",
    description:
      "Una selección cuidada de especias enteras y molidas. Pimentones, comino, azafrán, curry, hierbas mediterráneas y mezclas de la casa.",
    image:
      "https://images.unsplash.com/photo-1591272216626-b09e38519371?auto=format&fit=crop&w=1600&q=88",
  },
  {
    id: "frutos-secos",
    label: "Frutos secos",
    title: "Frutos secos",
    subtitle: "Variedad seleccionada",
    description:
      "Almendras, nueces, anacardos, pistachos y dátiles. Naturales, tostados o garrapiñados, listos para llevar al peso.",
    image:
      "https://images.unsplash.com/photo-1769255484233-94ece98f722d?auto=format&fit=crop&w=1600&q=88",
  },
  {
    id: "frutas",
    label: "Frutas",
    title: "Frutas de temporada",
    subtitle: "Recogidas en su punto",
    description:
      "Cada semana la fruta que el sol ha madurado. Variedades locales de Andalucía elegidas pieza a pieza.",
    image:
      "https://images.unsplash.com/photo-1620217349590-7b4e3ec6898a?auto=format&fit=crop&w=1600&q=88",
  },
  {
    id: "verduras",
    label: "Verduras",
    title: "Verduras frescas",
    subtitle: "De huerta",
    description:
      "Hortalizas y verduras de mercado, recibidas a primera hora. Tomates, pimientos, espárragos y lo mejor de cada estación.",
    image:
      "https://images.unsplash.com/photo-1690934164598-99267828e900?auto=format&fit=crop&w=1600&q=88",
  },
  {
    id: "cafe",
    label: "Café",
    title: "Café de especialidad",
    subtitle: "Recién tostado",
    description:
      "Café de especialidad con tueste reciente. Origen único y mezclas seleccionadas, en grano o molido.",
    image:
      "https://images.unsplash.com/photo-1447933601403-0c6688de566e?auto=format&fit=crop&w=1600&q=88",
  },
  {
    id: "miel",
    label: "Miel",
    title: "Mieles de origen",
    subtitle: "Local y andaluza",
    description:
      "Gran variedad de mieles de origen local y andaluz. Azahar, romero, milflores, caña… cada una con su carácter y su tarro.",
    image:
      "https://images.unsplash.com/photo-1558642452-9d2a7deb7f62?auto=format&fit=crop&w=1600&q=88",
  },
  {
    id: "deshidratadas",
    label: "Deshidratadas",
    title: "Frutas deshidratadas",
    subtitle: "Naturalmente dulces",
    description:
      "Dátiles, higos, orejones, mango, piña, plátano, arándanos. Perfectos para picar y para repostería.",
    image:
      "https://images.unsplash.com/photo-1641291361624-38b69b86b1cf?auto=format&fit=crop&w=1600&q=88",
  },
  {
    id: "aceitunas",
    label: "Aceitunas y encurtidos",
    title: "Aceitunas y encurtidos",
    subtitle: "Locales y aliñadas en casa",
    description:
      "Aceitunas aliñadas, manzanilla, cornicabra, kalamata. Pepinillos, alcaparras, banderillas y guindillas de productores cercanos.",
    image:
      "https://images.unsplash.com/photo-1634737000609-a927ce72cc2c?auto=format&fit=crop&w=1600&q=88",
  },
  {
    id: "arabes",
    label: "Productos árabes",
    title: "Dulces marroquíes",
    subtitle: "Sabores del zoco",
    description:
      "Cuernos de gacela, chebakia, ghriba, makrout y dulces tradicionales marroquíes. Junto a cuscús, harissa, ras el hanout, tahini, té moruno y dátiles.",
    image:
      "https://images.unsplash.com/photo-1574810134700-b6ba48d151a0?auto=format&fit=crop&w=1600&q=88",
  },
  {
    id: "pan-cateto",
    label: "Pan cateto",
    title: "Pan cateto",
    subtitle: "Horneado tradicional",
    description:
      "Pan cateto andaluz de masa madre, miga densa y corteza crujiente. Recibido a diario de obrador artesano.",
    image:
      "https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=1600&q=88",
  },
  {
    id: "quesos",
    label: "Quesos",
    title: "Quesos selectos",
    subtitle: "Tabla de variedades",
    description:
      "Selección de quesos curados, semicurados y frescos. Variedades artesanas locales y especialidades de origen.",
    image:
      "https://images.unsplash.com/photo-1452195100486-9cc805987862?auto=format&fit=crop&w=1600&q=88",
  },
  {
    id: "artesanos",
    label: "Artesanos",
    title: "Productos artesanos",
    subtitle: "Oficio que se nota",
    description:
      "Aceites, conservas y dulces de obradores locales. Recetas de toda la vida, sin prisa.",
    image: "/brand/aceite-oliva.jpg",
  },
  {
    id: "cestas",
    label: "Cestas",
    title: "Cestas a medida",
    subtitle: "Regalo y bienvenida",
    description:
      "Componemos cestas para regalo, eventos o apartamentos turísticos. Cuéntanos lo que necesitas y la preparamos.",
    image:
      "https://images.unsplash.com/photo-1628689469838-524a4a973b8e?auto=format&fit=crop&w=1600&q=88",
  },
  {
    id: "hosteleria",
    label: "Hostelería",
    title: "Servicio a hostelería",
    subtitle: "Restaurantes, hoteles y apartamentos",
    description:
      "Suministro a restaurantes, hoteles, chiringuitos y apartamentos turísticos de la Costa del Sol. Producto seleccionado, entrega regular y atención personalizada.",
    image:
      "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1600&q=88",
  },
];
